/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Tool_Grants_Open_LabelInputs */



/**
* | output |
* | --- |
* | "Manage tools for {name}" |
*
* @param {Spaces_Tool_Grants_Open_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_open_label = /** @type {((inputs: Spaces_Tool_Grants_Open_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_Open_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tools für ${i?.name} verwalten`)
	return /** @type {LocalizedString} */ (`Manage tools for ${i?.name}`)
});